import { FC } from 'react'
import type { IconProps } from '../types'

const SendIcon: FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.6242 1.30281C17.9207 1.19185 18.2676 1.25579 18.5061 1.49421C18.7448 1.73295 18.808 2.08031 18.6965 2.37703L13.1613 18.1925C13.0484 18.5146 12.7505 18.7351 12.4094 18.7491C12.068 18.763 11.7523 18.5672 11.6135 18.255L8.57736 11.4229L1.74533 8.38679C1.43309 8.24802 1.23726 7.93229 1.25119 7.59089C1.2652 7.24977 1.48568 6.95192 1.80783 6.83894L17.6242 1.30281ZM10.2024 10.9766L12.2834 15.6573L15.924 5.25495L10.2024 10.9766ZM4.34298 7.71687L9.02365 9.79792L14.7453 4.07624L4.34298 7.71687Z'
      fill={color}
    />
  </svg>
)

export default SendIcon
